import { mutator } from 'satcheljs';
import {
    expandFileExtensionsFilterMenu,
    collapseFileExtensionsFilterMenu,
} from 'owa-files-filter-contextmenu';
import { getFilterMenuStore } from '../store/FilterMenuStore';
import { logUsage } from 'owa-analytics';
import { getParameterStore } from '../store/ParametersStore';

mutator(expandFileExtensionsFilterMenu, () => {
    const filterMenuStore = getFilterMenuStore();

    logUsage('FilesViewExpandFilter', { scenario: getParameterStore().scenarioName });

    filterMenuStore.isExtensionFilterExpanded = true;
});

mutator(collapseFileExtensionsFilterMenu, () => {
    const filterMenuStore = getFilterMenuStore();

    logUsage('FilesViewCollapseFilter', { scenario: getParameterStore().scenarioName });

    filterMenuStore.isExtensionFilterExpanded = false;
});
